<template>
  <div class="formdata heating_location">
    <div class="header-container">
    <h3 id="heating_location_question">Wo befindet sich die Heizung?</h3>
</div>
    <CustomRadioGroup
        :options="heatingLocations"
        v-model="selectedAnswer"
        aria-labelledby="heating_location_question"
        :unique="heatingLocationQuestion"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'heating_location_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>



    <button class="button button_yellow right" v-if="selectedAnswer" @click="submit">Weiter</button>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useWorkflowStore} from '../../stores/workflow.js';
import CustomRadioGroup from "@/components/CustomRadioGroup.vue";
import {heatingLocations, heatingLocationsApi} from "@/data/heatingLocations.js";

const workflowStore = useWorkflowStore();


const getEventData = (selectedValue) => {
  const fullAnswer = heatingLocations.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: heatingLocationsApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available
    };
  }
  return null;
};


const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.heating_location || null;
  },
  set(newValue) {
    // Der Setter wird aufgerufen, sobald der Benutzer einen Radio-Button auswählt.
    // Hier senden wir ein Event, das den Wert sofort im Store aktualisiert.
    const eventData = getEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_HEATING_LOCATION_ANSWER',
      data: eventData,
    });
  }
});



const submit = () => {
  // Diese Funktion wird nur aufgerufen, wenn der "Weiter"-Button geklickt wird.
  // Der Wert ist bereits durch den Setter des computed properties im Store gespeichert.
  if (selectedAnswer.value) {
    const eventData = getEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

<style scoped>




</style>